import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export const EndStatus = memo(() => {
  const { t } = useTranslation();
  return <div className="text-sm text-foreground/70 text-center leading-5 font-normal py-4">{t('all-items-loaded')}</div>;
});
EndStatus.displayName = 'EndStatus';
